import React, { useCallback, useRef } from 'react';

import { ColDef, GridReadyEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

import { generateColumnDefs } from '../../utils/helpers';
import './JsonTableDisplay.scss';

interface JsonTableDisplayProps {
    data: any[];
}

export const JsonTableDisplay: React.FC<JsonTableDisplayProps> = ({ data }) => {
    const gridRef = useRef<AgGridReact>(null);

    // Handle grid ready event and auto-size columns
    const onGridReady = useCallback((params: GridReadyEvent) => {
        // Auto-size all columns
        params.api.sizeColumnsToFit();
    }, []);

    if (!data || data.length === 0) {
        return <div>No data to display</div>;
    }

    const columnDefs: ColDef[] = generateColumnDefs(data[0]);

    return (
        <div className="ag-theme-alpine" style={{ height: '600px', minWidth: '800px' }}>
            <AgGridReact
                ref={gridRef}
                rowData={data}
                columnDefs={columnDefs}
                pagination={true}
                paginationPageSize={20}
                onGridReady={onGridReady}
            />
        </div>
    );
};
